import { Fragment } from 'react';
import styles from './AnimatedHeader.module.css';

export const AnimatedHeader = ({ title = 'КВИЗ', titleFontSize }) => {
    const letters = title.split('');
    
    return (
        <div className={styles.container}>
            <h1 className={styles.wave} style={{ fontSize: `${titleFontSize}rem` }}>
                <span>
                {letters.map((letter, i) => (<Fragment key={i}>
                    <span>{letter}</span>
                </Fragment>))}
                </span>
            </h1>
        </div>
    )
}